import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { Hero } from './components/hero/Hero';
import { TrustStrip } from './components/sections/TrustStrip';
import { Problems } from './components/sections/Problems';
import { Solution } from './components/sections/Solution';
import { CoreContent } from './components/sections/CoreContent';
import { InsidePreview } from './components/preview/InsidePreview';
import { Bonuses } from './components/bonuses/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { FinalComparison } from './components/sections/FinalComparison';
import { Footer } from './components/layout/Footer';
import { StickyBar } from './components/layout/StickyBar';
import { initMetaPixel } from './utils/metaPixel';
const PAGE_TITLE = 'Flag Football Class Ready — Your Whole School Year of Flag Football, Already Planned';
const PAGE_DESCRIPTION = 'A whole school year of beginner flag football classes for PE teachers working with ages 10–14, plus five bonus resources. $27 USD launch price. Pre-release preview.';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'en';
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = PAGE_DESCRIPTION;
    initMetaPixel();
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="38li7lebna3n2">
      <div className="min-h-screen w-full overflow-x-clip bg-mint font-sans text-base text-ink" data-id="element-1" data-mp="38kglmet3bwqk">
        <a href="#main" className="sr-only bg-gold px-5 py-3 font-bold text-ink focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[70]" data-id="element-2" data-mp="3dm5ze27p6oic">
          Skip to content
        </a>
        <main id="main" data-id="element-3" data-mp="swgmhuqk1csa">
          <Hero data-id="element-4" data-mp="35ypsmahfq2i" />
          <TrustStrip data-id="element-5" data-mp="35gkz19r83iz" />
          <Problems data-id="element-6" data-mp="34x31kk3tf4y" />
          <Solution data-id="element-7" data-mp="38ktuby5znfz" />
          <CoreContent data-id="element-8" data-mp="3ud1gzdqblwcq" />
          <InsidePreview data-id="element-9" data-mp="3udkmtw2p4uae" />
          <Bonuses data-id="element-10" data-mp="3uc9jfxd5xojt" />
          <Offer data-id="element-11" data-mp="3uevqzx020421" />
          <Guarantee data-id="element-12" data-mp="d4nuteha5g1c" />
          <Faq data-id="element-13" data-mp="d4xphfd9sbdd" />
          <FinalComparison data-id="element-14" data-mp="d3mi75km8lhi" />
        </main>
        <Footer data-id="element-15" data-mp="d2bjhk6123x9" />
        <StickyBar data-id="element-16" data-mp="85uj9rljzz3t" />
      </div>
    </MotionConfig>;
}